import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { makeStyles } from "@mui/styles";
import logoLyra from "../../assets/img/LogoLyra.png";

const useStyles = makeStyles({
  brandRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 20,
  },
  logo: {
    width: "min(420px, 70%)",
    height: "auto",
    objectFit: "contain",
    userSelect: "none",
    mixBlendMode: "screen",
  },
  logoMobile: {
    width: "min(220px, 55%)",
    height: "auto",
    objectFit: "contain",
    mixBlendMode: "screen",
  },
  cartIcon: {
    color: "#FFFFFF !important",
    height: "72px !important",
    width: "72px !important",
    marginRight: "0 !important",
    flexShrink: 0,
  },
  cartIconMobile: {
    color: "#FFFFFF !important",
    height: "48px !important",
    width: "48px !important",
    marginRight: "0 !important",
    flexShrink: 0,
  },
});

export const AuthBrandPanel = ({ isMobile = false }) => {
  const classes = useStyles();

  return (
    <div className={classes.brandRow}>
      <img
        className={isMobile ? classes.logoMobile : classes.logo}
        src={logoLyra}
        alt="Lyra M2M"
      />
      <ShoppingCartOutlinedIcon
        className={isMobile ? classes.cartIconMobile : classes.cartIcon}
      />
    </div>
  );
};
